import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-emergency01-top-bar',
  templateUrl: './emergency01.component.html',
  styleUrls: ['./emergency01.component.scss'],
  standalone: true,
  imports: [ MatIconModule]
})
export class Emergency01Component {

  constructor(private router: Router) { }

  goToHome() {
    this.router.navigate(['/home']);
  }

}